import styled from 'styled-components';

import { styledLayout } from '@pkg/primitives';

export const ChipMemberWrapper = styled.div<{ $clickable?: boolean }>`
    ${styledLayout.fullWidthFix};
    display: inline-flex;
    border-radius: 999px;
    transition-property: box-shadow;
    transition-duration: ${({ theme }) => theme.transitions.speeds.fast}s;
    transition-timing-function: ${({ theme }) => theme.transitions.easesCss.on};

    &:hover {
        box-shadow: ${({ $clickable }) => ($clickable ? '0 0 14px rgba(82, 61, 241, 0.8)' : undefined)};
    }

    &:active {
        box-shadow: ${({ $clickable }) => ($clickable ? '0 0 14px rgba(82, 61, 241, 0.6)' : undefined)};
    }
`;
